import React, { useContext, useEffect, useState } from "react";
import CardInfo from "./CardInfo";
import { Card } from "reactstrap";
import backArrow from "./../../images/backArrow.svg";
import CreateLeadMaster from "../layout/Leads/CreateLeadMaster";
import { Modal, ModalHeader } from "reactstrap";
import Service from "../../services";
import CreateLeadForm from "../layout/Leads/NewLead/CreateLeadForm";
import "./prospectingDetailsPage.scss";
import { ReactComponent as CreditIcon } from "../../images/credit-cardIcon.svg";
import { ReactComponent as DDAIcon } from "../../images/DDAIcon.svg";
import { ReactComponent as LoanIcon } from "../../images/LoanIcon.svg";
import ReassignModal from "./ReassignModal";
import { useNavigate, useParams } from "react-router-dom";
import AddLabel from "./AddLabel";
import { getDisplayPhoneNumber } from "../../utils/GeneralUtils";
import UserIcon from "../../images/user.svg";
import { catchError } from "../../utils/Utils";
import { AxiosError, AxiosResponse } from "axios";
import { BankUserContext } from "../../bankUserContext";
import { WatchlistItem } from "../../models/WatchListModel";
import { ReactComponent as ViewIcon } from "../../images/viewNew.svg";
import { ReactComponent as Watch } from "../../images/watch-icon.svg";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import { RoutesEnum } from "../../utils/RoutesUtil";
import Icon from "../../utils/Icon";
import { TriggerContext } from "../../Context/TriggerContext";
import { TrackersEnum } from "../../models/TrackerModel";
import RoleAuthorization from "../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";
import EllipsisTooltip from "../../utils/EllipsisTooltip";
import DynamicProductIcon from "../../commonfields/DynamicProductIcon";
import HouseHoldInfo from "./HouseHoldInfo";
// import context from "react-bootstrap/esm/AccordionContext";
interface leadprops {
  leadData?: any;
  getLeadData?: any;
  users?: any;
  getReassignedUsers?: any;
  trackerName: string;
}
function LeadData(props: leadprops) {
  // const [leadData, setLeadData] = useState<any>();
  const [editCompanyModal, setEditCompanyModal] = useState(Boolean);

  const bankUserContext = useContext(BankUserContext);
  const service = new Service();
  const navigate = useNavigate();
  const params = useParams();
  const [reassignModal, setReassignModal] = useState(Boolean);
  const [loader, setLoader] = useState(Boolean);
  const { clientId, clientProductsId } = useParams();
  const [users, setUsers] = useState([]);
  const [companyLogo, setCompanyLogo] = useState<
    any | string | null | undefined
  >(null);
  const [watchListId, setWatchListId] = useState<string | null | undefined>(
    null
  );
  const clientContext = useContext(TriggerContext);

  const getReassignedUsers = () => {
    let payload = {
      screen: "CustomerDetails",
      sections: "getReassignUsers",
      orgId: bankUserContext.bankuserDetails?.organization.orgId,
      isJsonReturnObject: false,
    };
    service
      .getLeadsData(payload)
      .then((res: any) => {
        if (res?.data?.length > 0) {
          setUsers(
            (res?.data)?.map((n: any) => {
              return n;

            })
          );
        } else if (res?.data?.length === 0) {
          toast.error("No SBM users are present");
        }
      })

      .catch((err: any) => { });
  };

  const showreassignModal = () => {
    setReassignModal((prev) => !prev);
  };
  const reAssignClient = (assignTo: string) => {
    const payLoad = {
      sections: "updateClientProducts",
      clientId: clientId,
      assignTo: assignTo,
      clientProductId: clientProductsId,
    };
    setLoader(true);
    service
      .reAssignClient(payLoad)
      .then(() => {
        setReassignModal(false);
        props.getLeadData();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getReassignedUsers();
  }, []);

  useEffect(() => {
    if (props?.leadData) getCompanyLogo();
  }, [props?.leadData]);

  const toggleEditCompanyModal = () => setEditCompanyModal((prev) => !prev);

  useEffect(() => {
    props?.getLeadData();
    if (bankUserContext.bankuserDetails?.userId) {
      getWatchListData();
    }
  }, [bankUserContext.bankuserDetails?.userId]);

  const backArrowHandler = () => {
    let url = `/${RoutesEnum.TRACKER}/${params?.trackerName}`;
    if (params?.trackerName?.includes(TrackersEnum.APPLICATIONS)) {
      const selectedProductRaw = sessionStorage.getItem("selectedProduct");
      if (selectedProductRaw) {
        const selectedProduct = JSON.parse(selectedProductRaw);
        if (selectedProduct) {
          url = `${url}/${selectedProduct?.orgLevelProductId}`;
        }
      }
    }
    if (params?.trackerName?.includes(TrackersEnum.OPPORTUNITIES)) {
      const selectedProductRaw = sessionStorage.getItem("selectedProduct");
      if (selectedProductRaw) {
        const selectedProduct = JSON.parse(selectedProductRaw);
        if (selectedProduct) {
          url = `${url}/${selectedProduct?.orgLevelProductId}`;
        }
      }
    }
    if (params?.trackerName?.includes(TrackersEnum.UNDERWRITING)) {
      const selectedProductRaw = sessionStorage.getItem("selectedProduct");
      if (selectedProductRaw) {
        const selectedProduct = JSON.parse(selectedProductRaw);
        if (selectedProduct) {
          url = `${url}/${selectedProduct?.orgLevelProductId}`;
        }
      }
      else {
        const orgProductsListRaw = sessionStorage.getItem("orgProductsList")
        const orgProductsList = orgProductsListRaw && JSON.parse(orgProductsListRaw)
        url = `${url}/${orgProductsList[2].orgLevelProductId}`;
      }
    }
    navigate(url);
  };

  const contactCols = [
    [
      { label: "Name", name: "contactName" },
      { label: "Address", name: "address" },
    ],
    [{ label: "Title", name: "title" }],
    [{ label: "Birth Date", name: "dob" }],
    [
      { label: "Email", name: "email" },
      { label: "Email Type", name: "emailType" },
    ],
    [
      { label: "Phone", name: "phoneNumber" },
      { label: "Phone Type", name: "phoneType" },
    ],
  ];
  // const companyCols = [
  //   [
  //     { label: "Name", name: "contactName" },
  //     { label: "Address", name: "address" },
  //   ],
  //   [
  //     { label: "Name", name: "contactName" },
  //     { label: "Address", name: "address" },
  //   ],
  //   [
  //     { label: "Name", name: "contactName" },
  //     { label: "Address", name: "address" },
  //   ],

  //   [{ label: "Title", name: "title" }],
  //   [{ label: "Birth Date", name: "dob" }],
  //   [
  //     { label: "Email", name: "email" },
  //     { label: "Email Type", name: "emailType" },
  //   ],
  //   [
  //     { label: "Phone", name: "phoneNumber" },
  //     { label: "Phone Type", name: "phoneType" },
  //   ],
  // ];

  const companyCols = [
    [
      { label: "Merchant Company Name", name: "businessName" },
      { label: "Address", name: "address" },
      
    ],
    [{ label: "Industry Type", name: "industryType" }],
    [
      { label: "Industry Sub Type", name: "industrySubType" },
      { label: "# of Accounts", name: "account" },
    ],
    [
      { label: "Email", name: "businessEmail" },
      { label: "Email Type", name: "businessEmailType" },
    ],
    [
      { label: "Phone", name: "businessPhoneNumber" },
      { label: "Phone Type", name: "businessPhoneType" },
    ],
  ];

  const detailsCols = [[{ label: "Labels", name: "label" }]];
  const detailsData = {
    label: ["label"],
  };

  const [labelData, setLabelData] = useState(detailsData);

  const addLabel = (label: any) => {
    let temp = JSON.parse(JSON.stringify(labelData));
    temp.label = [...temp.label, label];
    setLabelData(temp);
  };
  const removeLabel = (label: any) => {
    let temp = JSON.parse(JSON.stringify(labelData));
    temp.label = temp.label.filter((l: any) => l !== label);
    setLabelData(temp);
  };

  const getWatchListData = () => {
    const watchListData = {
      screen: "prospectTR",
      sections: "watchlist",
      isJsonReturnObject: false,
      userId: bankUserContext.bankuserDetails?.userId,
    };

    service
      .getWatchListByUserId(watchListData)
      .then((response: AxiosResponse<WatchlistItem[]>) => {
        response.data
          ? setWatchListId(
            response.data?.find((m) => m.clientId == clientId)?.watchlistId
          )
          : setWatchListId(null);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const removeWatchlist = () => {
    if (watchListId) {
      const x = {
        sections: "WatchList",
        watchlistIds: [watchListId],
      };

      service
        .removeWatchList(x)
        .then(() => {
          getWatchListData();
        })
        .catch((err: AxiosError) => {
          catchError(err, true);
        });
    }
  };

  const addWatchList = () => {
    const data = {
      sections: "watchlist",
      data: {
        userId: bankUserContext.bankuserDetails?.userId,
        clientId: clientId,
        status: "active",
      },
    };
    service
      .addToWatchlist(data)
      .then(() => {
        getWatchListData();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };
  const getCompanyLogo = () => {
    if (props?.leadData?.[0]?.profileDocId) {
      service.getLogo(props?.leadData?.[0]?.profileDocId).then((res: any) => {
        setCompanyLogo(res.data);
      });
    } else {
      setCompanyLogo(null);
    }
  };

const isHouseHoldInfo = (products: any[] = []) => {
  return Array.isArray(products) && products?.find((p: any) => p?.product_name === "Lüt");
};
  useEffect(() => {
    getCompanyLogo();
  }, []);
  const productObj ={
    productName:props?.leadData?.[0]?.clientProducts?.[0]?.product_name,
    productId:props?.leadData?.[0]?.clientProducts?.[0]?.product_id
  }
  return (
    <>{clientContext?.readOnlyMode &&
      <div className="archiveBannerDiv">
        <p className="archiveBanner">Archived</p>
      </div>}
      <div className="detailspage-leadinfo">
        <div className={`leadDetailsCards`}>
          <img
            src={backArrow}
            alt="backButton"
            className="back-icon"
            onClick={() => backArrowHandler()}
          />
          {props.trackerName == "caseTracker" ? (
            <></>
          ) : (
            <div className="cardinfo">
              <Card>
                <div className="upload-container">
                  {companyLogo?.filePath ? (
                    <div className="image-icon-container">
                      <Icon
                        width={50}
                        height={50}
                        src={
                          companyLogo?.fileName
                            ? "data:image/png;base64," + companyLogo?.fileContent
                            : companyLogo?.fileContent
                        }
                      ></Icon>
                    </div>
                  ) : (
                    <FontAwesomeIcon className="upload-icon" icon={faImages} />
                  )}
                  <div>
                    <h4 className="cardinfoHeading">
                      <EllipsisTooltip
                        text={
                          props?.leadData?.[0]?.businessInfo?.[0]?.businessName
                        }
                        maxLine={25}
                      ></EllipsisTooltip>
                    </h4>
                    <span className="checkTag">
                      {props?.leadData?.[0]?.prospect}
                    </span>
                  </div>
                </div>
                <div className="contactinfobottom">
                  <div className="schedule-wrapper">
                    <p className="nextaction">Next Actions</p>
                    <h6 className="fllowupcall">
                      <span>
                        {props?.leadData?.[0].clientActions?.[0].interactionName
                          ?
                          <><span>{props?.leadData?.[0].clientActions?.[0]?.nextActionDate}-{props?.leadData?.[0].clientActions?.[0]?.interactionName}</span>
                            {/* <span className="interactionDate">
                            {props?.leadData?.[0].clientActions?.[0]?.nextActionDate}</span> */}
                          </> : "--"}

                      </span>
                    </h6>
                  </div>

                  <div className="payment-wrapper">
                    {props?.leadData?.[0]?.clientProducts?.[0]?.product_id !==
                      null ? (
                      <div className="credit-card">
                        <div className="credit-card">
                          {/* <DDAIcon title="" /> */}
                          <DynamicProductIcon productName={productObj.productName} />
                          <h6>
                            {
                              props?.leadData?.[0]?.clientProducts?.[0]
                                .product_name
                            }
                          </h6>
                        </div>
                      </div>
                    ) : (
                      <div className="credit-card">No Product</div>
                    )}
                  </div>
                  <div className="createlead-btn">
                    {RoleAuthorization(
                      Pages.customerDetailsPage,
                      actionAuthorization.createLead
                    ) && !clientContext?.readOnlyMode && (
                        <CreateLeadMaster           //details pge createLeadButton
                          genericTracker={false}
                          clientId={clientId}
                          pclientId={
                            props.leadData && props?.leadData[0]?.parentClientId
                          }
                          leadData={props.leadData}
                          fromDetailsPage={true}
                          isConfirmToCreate={true}
                          companyLogo={companyLogo}
                          getCompanyLogo={getCompanyLogo}
                          getLeadData={props?.getLeadData}
                          clientProductsContactMappingId={props.leadData && props?.leadData[0].clientProductsContactMappingId}
                        />
                      )}
                  </div>
                  <div className="action-wrapper d-flex">
                    <div className="userName">
                      <img className="usericon" src={UserIcon} alt="user" />
                      <span className="name">
                        {props?.leadData?.[0]?.clientProducts?.[0].assignto}
                      </span>
                    </div>
                    {RoleAuthorization(
                      Pages.customerDetailsPage,
                      actionAuthorization.accessReassign
                    ) && !clientContext?.readOnlyMode && (
                        <div className="reassign" onClick={showreassignModal}>
                          Reassign
                        </div>
                      )}
                  </div>
                </div>
              </Card>
            </div>
          )}
          <div className="contactinfo">
            <CardInfo
              title="Contact Info"
              cols={contactCols}
              data={props.leadData?.[0]?.contactInfo?.[0] || {}}
              isAddLable={false}
              getLeadData={props?.getLeadData}
              clientId={clientId}
            ></CardInfo>
          </div>

          <div className="companyinfo">  
        {isHouseHoldInfo (props?.leadData?.[0]?.clientProducts)?<HouseHoldInfo  clientId={clientId} data={props?.leadData?.[0]?.contactInfo?.[0] || {}}/> :      
            <CardInfo
              title="Company Info"
              cols={companyCols}
              data={props?.leadData?.[0]?.businessInfo?.[0] || {}}
              isEditable={true}
              isAddLable={false}
              getLeadData={props?.getLeadData}
              clientId={clientId}
              trackerName={props?.trackerName}
            ></CardInfo>}
          </div>

          <div className="info">
            {props?.trackerName !== "caseTracker" && !clientContext?.readOnlyMode &&
              (watchListId ? (
                <div className="MywatchlistContainer" onClick={removeWatchlist}>
                  <p className="addWatchList inFocus">In Focus</p>
                  <ViewIcon />
                </div>
              ) : (
                <div
                  className="addwatchlistContainer"
                  onClick={() => addWatchList()}
                >
                  <p className="addWatchList">Add to In Focus</p>
                  <Watch />
                </div>
              ))}

            <AddLabel
              clientId={clientId}
              getLeadData={props.getLeadData}
              labels={props.leadData?.[0].clientLabels || []}
              trackerName={props?.trackerName}
            />
          </div>
        </div>

        <Modal
          className="popup-modal newLeadModal"
          isOpen={editCompanyModal}
          toggle={toggleEditCompanyModal}
        >
          <ModalHeader toggle={toggleEditCompanyModal}></ModalHeader>
          <CreateLeadForm
            toggleHandle={toggleEditCompanyModal}
            title={"Edit Company Info"}
          //leadInfo={generalInfoData}
          />
        </Modal>

        <ReassignModal
          reassignModal={reassignModal}
          leaddetails={props?.leadData}
          toggleModal={showreassignModal}
          user={users}
          reAssignClient={reAssignClient}
        />
      </div>
    </>
  );
}

export default LeadData;
